import { TableColumn } from "react-data-table-component";
import { IPropsRequisicion } from "../../store/settingsStore";
import DatosFacturacionDataTable from "../general/DatosFacturacionDataTable";
import { StyledContainerConcepto } from "../general/StylesUtils";
import AddItemModal from "../settings/AddItemModal";
import { useState } from "react";
import { formatMoney } from "../general/utils";

type DataRow = {
  month: string;
  ano: string;
  monto: string;
};

const headers = [
  { label: 'Mes', name: 'month', required: true},
  { label: 'Ano', name: 'ano', required: true},
  { label: 'Monto', name: 'monto', required: true},
  // { label: 'Correo', name: 'correo'},
  // { label: 'Puesto o Roll', name: 'puesto'},
];

const columns: TableColumn<DataRow>[] = [
  {
    name: "Mes",
    selector: row => row.month,
    sortable: true
  },
  {
    name: "Ano",
    selector: row => row.ano,
    sortable: true
  },
  {
    name: "Monto",
    selector: row => formatMoney(row.monto),
    sortable: true
  },
]

const AddConfigFacturacion = ({ showModal: showModalRequisicion = false, typeAction, setShowModal: setShowModalRequisicion,  handleSave }: IPropsRequisicion) => {
  const [facturacion , setFacturacion] = useState([])
  const handleSaveData = async(option: string, data: any) => {
    console.log("++OPTION > ", option)
    console.log("++DATA > ", data)
  }

  const onChangeSelect = ({value}: any) => {
    console.log("ACF > data: ", value)
    // const {value} = data
    if(value.length) {
      setFacturacion(value)
    }

  }
  const contentForm = () => {
    return (
      <StyledContainerConcepto className="row" style={{padding: "20px"}}>

        <DatosFacturacionDataTable columns={columns} headers={headers} dataDefault={facturacion} handleSaveContactos={onChangeSelect} />
      </StyledContainerConcepto>
    )
  }

  return (
    <AddItemModal keyModal="modal-servicio" typeAction={typeAction} showModal={showModalRequisicion} setShowModal={setShowModalRequisicion} handleSave={handleSaveData} >
      { contentForm() }
    </AddItemModal>
    )
}

export default AddConfigFacturacion;